import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-secondary-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="font-display text-xl text-white mb-4">
              <Link to="/">韩漫之家</Link>
            </h4>
            <p className="text-sm text-secondary-400 leading-relaxed">
              韩漫之家是韩国漫画在线观看平台，拥有海量正版韩漫资源，支持下拉式阅读，画质高清，更新快，为您提供安心阅读环境。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-800 hover:bg-secondary-700 transition-colors" rel="nofollow" aria-label="微博">
                <i className="ri-weibo-line text-secondary-300"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-800 hover:bg-secondary-700 transition-colors" rel="nofollow" aria-label="微信">
                <i className="ri-wechat-line text-secondary-300"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-800 hover:bg-secondary-700 transition-colors" rel="nofollow" aria-label="Bilibili">
                <i className="ri-bilibili-line text-secondary-300"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4">
              <Link to="/category/romance">漫画分类</Link>
            </h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-secondary-400 hover:text-primary-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors">首页</Link>
              </li>
              <li>
                <Link to="/category/romance" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors">全部漫画</Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors">关于我们</Link>
              </li>
              <li>
                <a href="#" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors" rel="nofollow">用户协议</a>
              </li>
              <li>
                <a href="#" className="text-sm text-secondary-400 hover:text-primary-400 transition-colors" rel="nofollow">隐私政策</a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4">联系我们</h4>
            <ul className="space-y-2 text-sm text-secondary-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>contact@hanmanzhijia.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>400-888-6666</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                <span>北京市朝阳区望京SOHO</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-500">
            &copy; 2026 韩漫之家 版权所有 | 京ICP备2024000001号
          </p>
          <p className="text-xs text-secondary-500">
            本站所有漫画均获得正版授权，侵权必究
          </p>
        </div>
      </div>
    </footer>
  );
}